import { makeStyles, Theme } from '@material-ui/core/styles';
import { colors } from 'design-system';

const useQuotationListCardStyles = makeStyles((theme: Theme) => ({
  root: {
    minHeight: theme.spacing(32),
  },
  rootContainer: {
    height: '100%',
    display: 'flex',
  },
  container: {
    position: 'relative',
  },
  rightAnchor: {
    display: 'inline-block',
    width: 'calc(93% - 40px)',
    marginLeft: theme.spacing(1.25),
    [theme.breakpoints.down('sm')]: {
      width: 'calc(90% - 40px)',
    },
  },
  borderHr: {
    border: 0,
    height: 0,
    borderTop: `1px dashed ${colors.silver}`,
  },
  borderEnsuranceSum: {
    border: 0,
    height: 0,
    borderTop: `1px solid #eaeaea`,
    marginTop: '18px',
    marginBottom: '12px',
  },
  editBtn: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  carModelText: {
    color: colors.abbey,
    fontSize: 15,
    fontWeight: 700,
  },
  spacer: {
    height: 20,
  },
  spacerSm: {
    height: 5,
  },
  spacerMd: {
    height: 8,
  },
}));

export default useQuotationListCardStyles;
